import ContactDetailsSection from './contact-details-section';

export default ContactDetailsSection;
